import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PendingBannerProps {
  pendingCount: number;
  selectedCount: number;
  onAcceptSelected: () => void;
  onRejectSelected: () => void;
}

export function PendingBanner({
  pendingCount,
  selectedCount,
  onAcceptSelected,
  onRejectSelected,
}: PendingBannerProps) {
  if (pendingCount === 0 && selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-4 mb-4 bg-yellow-50 border border-yellow-200 rounded-lg">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5 text-yellow-600" />
        <div>
          {selectedCount > 0 ? (
            <p className="text-sm font-medium text-yellow-800">
              {selectedCount} documento(s) seleccionado(s)
            </p>
          ) : (
            <p className="text-sm font-medium text-yellow-800">
              {pendingCount} documento(s) pendiente(s) de aceptación
            </p>
          )}
          <p className="text-xs text-yellow-600">
            Tienes 8 días desde la recepción para aceptar o rechazar
          </p>
        </div>
      </div>

      {selectedCount > 0 && (
        <div className="flex gap-2">
          <Button size="sm" onClick={onAcceptSelected}>
            Aceptar seleccionados
          </Button>
          <Button size="sm" variant="outline" onClick={onRejectSelected}>
            Rechazar seleccionados
          </Button>
        </div>
      )}
    </div>
  );
}
